import { SkillLabel } from '@/models/taxonomy/skills';
import type { CheckedSkill } from '@/packages/skill-management/context/types';

export const getManuallyAddedSkills = (
  selectedSkills?: CheckedSkill[],
  feedbackSkills?: CheckedSkill[],
  occupationSkills?: CheckedSkill[]
): CheckedSkill[] => {
  if (!selectedSkills?.length) return [];

  const feedbackIds = feedbackSkills?.map((s) => s.skill.id) ?? [];
  const occupationIds = occupationSkills?.map((s) => s.skill.id) ?? [];

  const manualSkills = selectedSkills.filter((item) => {
    const id = item.skill.id;
    const unset = !feedbackIds.includes(id) && !occupationIds.includes(id);
    const manuallyAdded = item.label === SkillLabel.ManuallyAdded;

    return unset || manuallyAdded;
  });

  return manualSkills.map((skill) => ({ ...skill, checked: true }));
};
